import { useSelector } from "react-redux";
import { selectAppPersonalizations } from "../services/utils/appInfoSlice";
import styled from 'styled-components'
import { DEVICE } from "../config/constants";


const DefaultH1 = styled.h1`
  /* Adapt the colors based on primary prop */
  color: ${props => props.$color};
  font-size: 24px;
  line-height: 120%;
  font-family: font_h1,Arial;
  font-weight: 700;
  @media ${DEVICE.tablet} { 
    font-size: 32px
  }
`;

export default function TitleH1({ size, className='', customize=false, children }) {

    const personalizations = useSelector(selectAppPersonalizations);

    return (
        <DefaultH1  className={className} $color={customize ? personalizations?.h1?.color : '#181818'}>
            {children}
        </DefaultH1>
    )
}

